module.exports = __webpack_public_path__ + "assets/img/sphere-block-bg.e3b2d0b9.jpg";